import React from 'react'
import ExcelDownload from './ExcelDownload';
function Exceldata() {
  return (
    <div>
        <br/>
        <br/>
             <div className="album py-2">
          <div className="container">
            <ExcelDownload/>
            </div>
          </div>
          <br/>
    </div>
  )
}

export default Exceldata